import React from "react";

const PhoneInput = React.forwardRef(
  (
    {
      id,
      label,
      placeholder,
      className = "",
      labelClass = "",
      inputClass = "",
      error,
      register,
      ...props
    },
    ref
  ) => {
    const handleInput = (e) => {
      // Allow only digits and a single leading +
      let value = e.target.value.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");

      // Enforce max 11 characters
      if (value.length > 12) {
        value = value.slice(0, 11);
      }

      e.target.value = value;
    };

    return (
      <div key={id} className={`flex flex-col gap-3 ${className}`}>
        {label && (
          <label htmlFor={id} className={`body-copy-small-text  ${labelClass}`}>
            {label}
          </label>
        )}

        <input
          id={id}
          ref={ref}
          placeholder={placeholder}
          inputMode="tel"
          pattern="^\+?[0-9]{0,11}$"
          maxLength={12}
          onInput={handleInput}
          className={`text-20px-23px text-ff-purple rounded-[21.5px] px-6 py-1 outline-none border-none ${inputClass}`}
          {...register}
          {...props}
        />

        {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";
export default PhoneInput;
